const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#12437c',
                hover: '#133566'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
